export default __webpack_public_path__ + "static/media/5.d2e80901.jpg";